import { InputAdornment, styled } from '@mui/material'

export const FormContainer = styled('div')({
  padding: 24,
})

export const FlexFormContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  padding: 16,
  width: 500,
})

export const ActionsContainer = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 8,
  paddingTop: 16,
})

export const ActionsApartContainer = styled(ActionsContainer)({
  justifyContent: 'space-between',
})

export const StartAdornment = styled(InputAdornment)({
  paddingTop: 1,
  paddingBottom: 5,
})
